import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Partner } from '../models/partner';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(private http: HttpClient) { }

  public getPartners() : Observable<Partner[]> {
    return this.http.get<Partner[]>(`${environment.API_URL}/partners`);
  }

  public deletePartner(id: number) : Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/partners/delete`, {id: id});
  }

  public createPartner(partner: Partner) : Observable<Partner> {
    return this.http.post<Partner>(`${environment.API_URL}/partners/create`, partner);
  }

  public updatePartner(partner: Partner) : Observable<Partner> {
    return this.http.post<Partner>(`${environment.API_URL}/partners/update`, partner);
  }
}
